"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getRandom = (numberOfQuestions) => {
    return (items) => {
        const randomItems = [];
        while (randomItems.length < numberOfQuestions) {
            const randomIndex = Math.floor(Math.random() * items.length);
            const randomItem = items.splice(randomIndex, 1)[0];
            randomItems.push(randomItem);
        }
        return randomItems;
    };
};
exports.default = getRandom;
//# sourceMappingURL=getRandom.js.map